import archidekt from '@/assets/ads/archidekt.webp'
import ckBuylist from '@/assets/ads/ckBuylist.webp'
import crossword from '@/assets/ads/crossword.webp'
import cs from '@/assets/ads/cs.webp'
import csb from '@/assets/ads/csb.webp'
import csHobbit from '@/assets/ads/csHobbit.webp'
import edhrecap from '@/assets/ads/edhrecap.webp'
import edhrecPatreon from '@/assets/ads/edhrecPatreon.webp'
import edhrecPatreon201 from '@/assets/ads/edhrecPatreon201.webp'
import edhrecPatreon202 from '@/assets/ads/edhrecPatreon202.webp'
import edhrecPatreon203 from '@/assets/ads/edhrecPatreon203.webp'
import gatherersTavernPoster from '@/assets/ads/gatherersTavern/16x9.webp'
import gatherersTavernBanner from '@/assets/ads/gatherersTavern/728x90.webp'
import gatherersTavernPosterAtla from '@/assets/ads/gatherersTavern/atla16x9.webp'
import gatherersTavernBannerAtla from '@/assets/ads/gatherersTavern/atla728x90.webp'
import gatherersTavernPosterAvatar from '@/assets/ads/gatherersTavern/avatar16x9.webp'
import gatherersTavernBannerAvatar from '@/assets/ads/gatherersTavern/avatar728x90.webp'
import spellifyDark1 from '@/assets/ads/spellifyDark1.webp'
import spellifyDark2 from '@/assets/ads/spellifyDark2.webp'
import spellifyLight1 from '@/assets/ads/spellifyLight1.webp'
import spellifyLight2 from '@/assets/ads/spellifyLight2.webp'
import tcgplayerIntl from '@/assets/ads/tcgplayerIntl.webp'
import tcgplayerMayhem from '@/assets/ads/tcgplayerMayhem.webp'

export const AD_GLOBAL_STATUS = {
  ADHESION_DESKTOP: true,
  ADHESION_MOBILE: true,
  ADHESION_TABLET: true,
  GALLERY_INCONTENT: false,
  LEADERBOARD: true,
  MID_BANNER: false,
  SIDEBAR: true,
  UVPPLUS: false,
}

export type AdUnitType = 'leaderboard' | 'midbanner' | 'poster'

export type GalleryIncontentGapType = {
  rowsBetween: number
  rowsFirst: number
}

export const GALLERY_INCONTENT_GAPS: Record<number, GalleryIncontentGapType> = {
  1: { rowsBetween: 10, rowsFirst: 5 },
  2: { rowsBetween: 5, rowsFirst: 2 },
  3: { rowsBetween: 3, rowsFirst: 1 },
  4: { rowsBetween: 2, rowsFirst: 1 },
}

export const MEDIAVINE_IDENTITY_EVENT = 'mediavineIdentityReady'
export const ADHESION_EVENT = 'adhesionchange'
export const ADHESION_DESKTOP_CSS_VAR = '--adhesion-desktop-height'
export const ADHESION_DESKTOP_WRAPPER_ID = 'adhesion_desktop_wrapper'
export const ADHESION_MOBILE_CSS_VAR = '--adhesion-mobile-height'
export const ADHESION_MOBILE_WRAPPER_ID = 'adhesion_mobile_wrapper'

export const MEDIAVINE_INLINE_CSS_CLASS = 'ArticlePage_content'
export const MEDIAVINE_INCONTENT_CSS_CLASS = 'mv_slot_target'

export type AdConfigType = {
  alt: string
  src: string
  url: string
}

export const AD_CONFIG_ENTRIES = {
  archidekt: { alt: 'Archidekt', src: archidekt.src, url: 'https://archidekt.com/landing' },
  ckBuylist: {
    alt: 'Get 30% Credit When Selling To Card Kingdom',
    src: ckBuylist.src,
    url: 'https://www.cardkingdom.com/purchasing/how_to_sell?partner=EDHRECSell&utm_medium=affiliate&utm_campaign=edhrec&partner_args=leaderboard',
  },
  crossword: { alt: 'EDHREC Crossword', src: crossword.src, url: 'https://edhrec.com/games/crossword' },
  cs: { alt: 'Cardsphere', src: cs.src, url: 'https://cardsphere.com' },
  csb: { alt: 'Commander Spellbook', src: csb.src, url: 'https://commanderspellbook.com' },
  csHobbit: { alt: 'Cardsphere', src: csHobbit.src, url: 'https://try.cardsphere.com/edhrec-hobbit' },
  edhrecap: { alt: 'EDHRecap', src: edhrecap.src, url: 'https://edhrec.com/newsletter' },
  edhrecPatreon: { alt: 'EDHREC Patreon', src: edhrecPatreon.src, url: 'https://patreon.com/edhrec' },
  edhrecPatreon201: { alt: 'EDHREC Patreon', src: edhrecPatreon201.src, url: 'https://patreon.com/edhrec' },
  edhrecPatreon202: { alt: 'EDHREC Patreon', src: edhrecPatreon202.src, url: 'https://patreon.com/edhrec' },
  edhrecPatreon203: { alt: 'EDHREC Patreon', src: edhrecPatreon203.src, url: 'https://patreon.com/edhrec' },
  gatherersTavernBannerAppa: {
    alt: "Gatherer's Tavern",
    src: gatherersTavernBannerAvatar.src,
    url: 'https://www.gathererstavern.com/products/appa-arty-box?variant=51428309303575',
  },
  gatherersTavernBannerAtlaAir: {
    alt: "Gatherer's Tavern",
    src: gatherersTavernBannerAtla.src,
    url: 'https://www.gathererstavern.com/products/avatar-the-last-airbender-domaru-boxes?variant=51428333748503',
  },
  gatherersTavernBannerAtlaEarth: {
    alt: "Gatherer's Tavern",
    src: gatherersTavernBannerAtla.src,
    url: 'https://www.gathererstavern.com/products/avatar-the-last-airbender-domaru-boxes?variant=51428333715735',
  },
  gatherersTavernBannerAtlaFire: {
    alt: "Gatherer's Tavern",
    src: gatherersTavernBannerAtla.src,
    url: 'https://www.gathererstavern.com/products/avatar-the-last-airbender-domaru-boxes?variant=51428333650199',
  },
  gatherersTavernBannerAtlaWater: {
    alt: "Gatherer's Tavern",
    src: gatherersTavernBannerAtla.src,
    url: 'https://www.gathererstavern.com/products/avatar-the-last-airbender-domaru-boxes?variant=51428333682967',
  },
  gatherersTavernBannerBetor: {
    alt: "Gatherer's Tavern",
    src: gatherersTavernBanner.src,
    url: 'https://www.gathererstavern.com/products/tarkir-dragons-keychains?variant=50469558223127',
  },
  gatherersTavernBannerMomo: {
    alt: "Gatherer's Tavern",
    src: gatherersTavernBannerAvatar.src,
    url: 'https://www.gathererstavern.com/products/momo-arty-box?variant=51428328505623',
  },
  gatherersTavernBannerNeriv: {
    alt: "Gatherer's Tavern",
    src: gatherersTavernBanner.src,
    url: 'https://www.gathererstavern.com/products/tarkir-dragons-keychains?variant=50469558255895',
  },
  gatherersTavernBannerShiko: {
    alt: "Gatherer's Tavern",
    src: gatherersTavernBanner.src,
    url: 'https://www.gathererstavern.com/products/tarkir-dragons-keychains?variant=50469558288663',
  },
  gatherersTavernBannerTeval: {
    alt: "Gatherer's Tavern",
    src: gatherersTavernBanner.src,
    url: 'https://www.gathererstavern.com/products/tarkir-dragons-keychains?variant=50469558321431',
  },
  gatherersTavernBannerUreni: {
    alt: "Gatherer's Tavern",
    src: gatherersTavernBanner.src,
    url: 'https://www.gathererstavern.com/products/tarkir-dragons-keychains?variant=50469558354199',
  },
  gatherersTavernPosterAppa: {
    alt: "Gatherer's Tavern",
    src: gatherersTavernPosterAvatar.src,
    url: 'https://www.gathererstavern.com/products/appa-arty-box?variant=51428309303575',
  },
  gatherersTavernPosterAtlaAir: {
    alt: "Gatherer's Tavern",
    src: gatherersTavernPosterAtla.src,
    url: 'https://www.gathererstavern.com/products/avatar-the-last-airbender-domaru-boxes?variant=51428333748503',
  },
  gatherersTavernPosterAtlaEarth: {
    alt: "Gatherer's Tavern",
    src: gatherersTavernPosterAtla.src,
    url: 'https://www.gathererstavern.com/products/avatar-the-last-airbender-domaru-boxes?variant=51428333715735',
  },
  gatherersTavernPosterAtlaFire: {
    alt: "Gatherer's Tavern",
    src: gatherersTavernPosterAtla.src,
    url: 'https://www.gathererstavern.com/products/avatar-the-last-airbender-domaru-boxes?variant=51428333650199',
  },
  gatherersTavernPosterAtlaWater: {
    alt: "Gatherer's Tavern",
    src: gatherersTavernPosterAtla.src,
    url: 'https://www.gathererstavern.com/products/avatar-the-last-airbender-domaru-boxes?variant=51428333682967',
  },
  gatherersTavernPosterBetor: {
    alt: "Gatherer's Tavern",
    src: gatherersTavernPoster.src,
    url: 'https://www.gathererstavern.com/products/tarkir-dragonstorm-domaru-boxes?variant=50297395282199',
  },
  gatherersTavernPosterMomo: {
    alt: "Gatherer's Tavern",
    src: gatherersTavernPosterAvatar.src,
    url: 'https://www.gathererstavern.com/products/momo-arty-box?variant=51428328505623',
  },
  gatherersTavernPosterNeriv: {
    alt: "Gatherer's Tavern",
    src: gatherersTavernPoster.src,
    url: 'https://www.gathererstavern.com/products/tarkir-dragonstorm-domaru-boxes?variant=50297395314967',
  },
  gatherersTavernPosterShiko: {
    alt: "Gatherer's Tavern",
    src: gatherersTavernPoster.src,
    url: 'https://www.gathererstavern.com/products/tarkir-dragonstorm-domaru-boxes?variant=50297395347735',
  },
  gatherersTavernPosterTeval: {
    alt: "Gatherer's Tavern",
    src: gatherersTavernPoster.src,
    url: 'https://www.gathererstavern.com/products/tarkir-dragonstorm-domaru-boxes?variant=50297395380503',
  },
  gatherersTavernPosterUreni: {
    alt: "Gatherer's Tavern",
    src: gatherersTavernPoster.src,
    url: 'https://www.gathererstavern.com/products/tarkir-dragonstorm-domaru-boxes?variant=50297395413271',
  },
  spellifyDark1: {
    alt: 'Spellify',
    src: spellifyDark1.src,
    url: 'https://edhrec.com/games/spellify?utm_campaign=dark1',
  },
  spellifyDark2: {
    alt: 'Spellify',
    src: spellifyDark2.src,
    url: 'https://edhrec.com/games/spellify?utm_campaign=dark2',
  },
  spellifyLight1: {
    alt: 'Spellify',
    src: spellifyLight1.src,
    url: 'https://edhrec.com/games/spellify?utm_campaign=light1',
  },
  spellifyLight2: {
    alt: 'Spellify',
    src: spellifyLight2.src,
    url: 'https://edhrec.com/games/spellify?utm_campaign=light2',
  },
  tcgplayerIntl: {
    alt: 'TCGPlayer International Shipping',
    src: tcgplayerIntl.src,
    url: 'https://partner.tcgplayer.com/c/4913290/3841229/21018',
  },
  tcgplayerMayhem: {
    alt: 'TCGPlayer Mayhem',
    src: tcgplayerMayhem.src,
    url: 'https://partner.tcgplayer.com/c/4913290/3904321/21018',
  },
}

export type AdIdType = keyof typeof AD_CONFIG_ENTRIES
export const AD_CONFIG: Record<AdIdType, AdConfigType> = AD_CONFIG_ENTRIES

/* eslint-disable sort/object-properties */
const AD_GATHERERS_TAVERN_POSTER_CONFIG_ENTRIES = {
  // Dragons of Tarkir
  'betor-ancestors-voice': 'gatherersTavernPosterBetor',
  'betor-kin-to-all': 'gatherersTavernPosterBetor',
  'neriv-crackling-vanguard': 'gatherersTavernPosterNeriv',
  'neriv-heart-of-the-storm': 'gatherersTavernPosterNeriv',
  'shiko-and-narset-unified': 'gatherersTavernPosterShiko',
  'shiko-paragon-of-the-way': 'gatherersTavernPosterShiko',
  'teval-arbiter-of-virtue': 'gatherersTavernPosterTeval',
  'teval-the-balanced-scale': 'gatherersTavernPosterTeval',
  'ureni-the-song-unending': 'gatherersTavernPosterUreni',
  'ureni-of-the-unwritten': 'gatherersTavernPosterUreni',
  // Avatar - Momo
  'momo-friendly-flier': 'gatherersTavernPosterMomo',
  'momo-playful-pet': 'gatherersTavernPosterMomo',
  'momo-rambunctious-rascal': 'gatherersTavernPosterMomo',
  // Avatar - Appa
  'appa-aangs-companion': 'gatherersTavernPosterAppa',
  'appa-loyal-sky-bison': 'gatherersTavernPosterAppa',
  'appa-steadfast-guardian': 'gatherersTavernPosterAppa',
  'appa-the-vigilant': 'gatherersTavernPosterAppa',
  // Avatar - Air
  'aang-a-lot-to-learn': 'gatherersTavernPosterAtlaAir',
  'aang-air-nomad': 'gatherersTavernPosterAtlaAir',
  'aang-airbending-master': 'gatherersTavernPosterAtlaAir',
  'aang-at-the-crossroads': 'gatherersTavernPosterAtlaAir',
  'aang-swift-savior': 'gatherersTavernPosterAtlaAir',
  'aang-the-last-airbender': 'gatherersTavernPosterAtlaAir',
  'avatar-aang': 'gatherersTavernPosterAtlaAir',
  'monk-gyatso': 'gatherersTavernPosterAtlaAir',
  // Avatar - Earth
  'bumi-eclectic-earthbender': 'gatherersTavernPosterAtlaEarth',
  'bumi-king-of-three-trials': 'gatherersTavernPosterAtlaEarth',
  'bumi-unleashed': 'gatherersTavernPosterAtlaEarth',
  'toph-earthbending-master': 'gatherersTavernPosterAtlaEarth',
  'toph-greatest-earthbender': 'gatherersTavernPosterAtlaEarth',
  'toph-hardheaded-teacher': 'gatherersTavernPosterAtlaEarth',
  'toph-the-blind-bandit': 'gatherersTavernPosterAtlaEarth',
  'toph-the-first-metalbender': 'gatherersTavernPosterAtlaEarth',
  // Avatar - Fire
  'iroh-dragon-of-the-west': 'gatherersTavernPosterAtlaFire',
  'iroh-firebending-instructor': 'gatherersTavernPosterAtlaFire',
  'iroh-grand-lotus': 'gatherersTavernPosterAtlaFire',
  'iroh-tea-master': 'gatherersTavernPosterAtlaFire',
  'uncle-iroh': 'gatherersTavernPosterAtlaFire',
  'zuko-avatar-hunter': 'gatherersTavernPosterAtlaFire',
  'zuko-conflicted': 'gatherersTavernPosterAtlaFire',
  'zuko-exiled-prince': 'gatherersTavernPosterAtlaFire',
  'zuko-firebending-master': 'gatherersTavernPosterAtlaFire',
  'zuko-redeemed': 'gatherersTavernPosterAtlaFire',
  'zuko-seeking-honor': 'gatherersTavernPosterAtlaFire',
  // Avatar - Water
  'katara-bending-prodigy': 'gatherersTavernPosterAtlaWater',
  'katara-heroic-healer': 'gatherersTavernPosterAtlaWater',
  'katara-seeking-revenge': 'gatherersTavernPosterAtlaWater',
  'katara-the-fearless': 'gatherersTavernPosterAtlaWater',
  'katara-water-tribes-hope': 'gatherersTavernPosterAtlaWater',
  'katara-waterbending-master': 'gatherersTavernPosterAtlaWater',
  'princess-yue': 'gatherersTavernPosterAtlaWater',
  'yue-the-moon-spirit': 'gatherersTavernPosterAtlaWater',
} as const satisfies Record<string, AdIdType>
/* eslint-enable sort/object-properties */

export type AdGatherersTavernPosterSlugType = keyof typeof AD_GATHERERS_TAVERN_POSTER_CONFIG_ENTRIES
export const getAdGatherersTavernPoster = (slugs: string[]): AdIdType | undefined => {
  const slug = slugs.find((s): s is AdGatherersTavernPosterSlugType => s in AD_GATHERERS_TAVERN_POSTER_CONFIG_ENTRIES)
  if (slug) return AD_GATHERERS_TAVERN_POSTER_CONFIG_ENTRIES[slug]
}
